import React from 'react';
import { Label, Button } from 'reactstrap';
import _ from 'lodash';
import PropTypes from 'prop-types';
import makeAnimated from 'react-select/animated';
import SwichButton from '../../commons/SwitchButton';
import SelectField from '../../components/Form/SelectField';

const EllenorzesiListaRow = (props) => {
  return (
    <div
      className="row"
      style={{
        padding: 20,
        margin: 6,
        borderStyle: 'dashed',
        borderColor: '#cfd8dc'
      }}
    >
      <div className="col-md-4">
        <SwichButton
          active={props.aktiv}
          trueLabel="Cikk"
          trueToggle={() => props.toggleEllenorzesiListaType(true, props.idx)}
          trueWidth={60}
          falseToggle={() => props.toggleEllenorzesiListaType(false, props.idx)}
          falseLabel="Karbantartott cikk"
          falseWidth={140}
          style={{ marginTop: 29 }}
        />
      </div>
      <div className="col-md-3">
        <SelectField
          variant='async'
          label='Cikk keresése:'
          name={'formCikkSearch-' + props.idx}
          id={'formCikkSearch-' + props.idx}
          placeholder="Kezdj el gépelni..."
          noOptionsMessage={() => 'Nincs keresési eredmény'}
          loadingMessage={() => 'Keresés...'}
          onChange={v => props.handleCikkChange(v, props.idx)}
          isClearable
          ignoreAccents={false}
          loadOptions={props.aktiv ? _.debounce(props.loadCikkOptions, 1000) : _.debounce(props.loadKarbantartottCikkOptions, 1000)}
          isLoading={false}
          getOptionValue={props.aktiv ? option => option.cid : option => option.kid}
          getOptionLabel={option => option.n}
          value={props.cikkValue}
          cache={false}
          autoload={false}
        />
      </div>
      <div className="col-md-3">
        <SelectField
          label='Ellenőrzési lista:'
          components={makeAnimated()}
          placeholder="Kezdj el gépelni..."
          noOptionsMessage={() => 'Nincs keresési eredmény'}
          loadingMessage={() => 'Keresés...'}
          isMulti
          ignoreAccents={false}
          onChange={v => props.handleListaChange(v, props.idx)}
          getOptionLabel={option => option.nev}
          getOptionValue={option => option.id}
          value={props.listaValue}
          name={'formEllListaSearch-' + props.idx}
          id={'formEllListaSearch-' + props.idx}
          isDisabled={props.listaOptions.length === 0}
          options={props.listaOptions}
        />
      </div>
      <div className="col-md-2">
        <Button
          type="button"
          style={{ marginTop: 29 }}
          color="danger"
          onClick={props.removeEllenorzesiLista}
        >
          <i class="fa fa-trash-o" />
        </Button>
      </div>
    </div>
  );
};

EllenorzesiListaRow.propTypes = {
  aktiv: PropTypes.bool,
  idx: PropTypes.number,
  cikkValue: PropTypes.oneOf([PropTypes.object, PropTypes.string]),
  mezonev: PropTypes.string,
  tartalom: PropTypes.string,
  updateMetaAdat: PropTypes.func,
  loadCikkOptions: PropTypes.func,
  loadKarbantartottCikkOptions: PropTypes.func,
  handleListaChange: PropTypes.func,
  handleCikkChange: PropTypes.func,
  listaValue: PropTypes.array,
  listaOptions: PropTypes.array,
  toggleEllenorzesiListaType: PropTypes.func,
  removeEllenorzesiLista: PropTypes.func
};

export default EllenorzesiListaRow;
